import 'css-chunksrc/client/scenes/taskRemoval/styles.scss';export default {
  "header": "_header_2rxh1_1",
  "details": "_details_2rxh1_5",
  "group": "_group_2rxh1_9",
  "text": "_text_2rxh1_13",
  "name": "_name_2rxh1_18",
  "main": "_main_2rxh1_24",
  "buttons": "_buttons_2rxh1_31"
};